import { render } from "./AvatarSpecial.vue?vue&type=template&id=e7d0157c&scoped=true"
import script from "./AvatarSpecial.vue?vue&type=script&lang=js"
export * from "./AvatarSpecial.vue?vue&type=script&lang=js"

import "./AvatarSpecial.vue?vue&type=style&index=0&id=e7d0157c&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.4.21_webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7d0157c"]])

export default __exports__